import { cm } from "@root/hooks/useClassesMerge";

import { createStyles, makeStyles } from "@mui/styles";
import { ChangeEvent } from "react";

export const Input2 = ({
    onChange,
    value,
    placeholder,
    type,
    disabledField
}: IInput) => {
    const classes = useStyles();

    return (
        <div className="input-group d-inline-flex align-items-start justify-content-start mb-1">
            <input
                id="login"
                type={type}
                className={cm("form-control", classes.customInput)}
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                disabled={disabledField}
            />
        </div>
    );
};

export const Select = ({
    onChange,
    value,
    placeholder,
}: ISelect) => {
    const classes = useStyles();

    return (
        <div className="input-group mb-2">
            <select
                value={value}
                onChange={onChange}
                className={cm("form-select", classes.select)}
            >
                <option value="">Select {placeholder}</option>

            </select>
        </div>
    );
};

export const useStyles = makeStyles(() =>
    createStyles({
        customInput: {
            width: "100%",
            height: "50px",
            borderRadius: "10px",
            border: "1px #cccccc solid",
            color: "#323232",
            backgroudColor: "white",

            "&:focus": {
                borderColor: "#dee2e6 !important",
                boxShadow: "none !important",
            },
        },

        select: {
            height: "50px",
            borderRadius: "10px",
            fontSize:"14px",
            border: "1px #E8E9EB solid",
            color: "#323232",
            backgroudColor: "white",

            "&:focus": {
                borderColor: "#dee2e6 !important",
                boxShadow: "none !important",
            },
        },

        inputGroupLetter: {
            color: "#323232",
            backgroundColor: "white",
            borderRight: "none",
        },

    })
);

interface IInput {
    // onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onChange?: any;
    value: string;
    placeholder: string;
    type?: string;
    disabledField?: boolean;

}

interface ISelect {
    onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
    value: string;
    placeholder: string;
}
